import blinkscribeapi from "../../api/blinkscribeapi";
import { requestSignMismatchConsent } from "./VisitConsentHost";
import { mismatchDetailsFromRefusal } from "../../notereview/noteVisit";

/* Every care sign-off (Note Review, the note editor, the PDF viewer) goes
   through signOffNote. BlinkScribe refuses to sign a note that was recorded on
   another day than its visit while the patient had a visit that day
   (409 VISIT_MISMATCH, patient 8823 09-29: it would post into the old visit's
   Athena encounter). The provider is then asked twice (VisitConsentHost) and,
   only after both steps, the sign-off is sent again with
   confirm_visit_mismatch=true.

   preConfirmed: the caller already asked twice (Note Review asks before the
   first call when it can see the mismatch).
   Returns the server body; { cancelled: true } when the provider declined.
   Any other error is thrown exactly as before (the callers show its message). */

export const VISIT_MISMATCH = "VISIT_MISMATCH";

export const isVisitMismatchRefusal = (err) =>
  err?.response?.status === 409 && err?.response?.data?.code === VISIT_MISMATCH;

export const signOffNote = async (body, { preConfirmed = false } = {}) => {
  const send = (confirm) =>
    blinkscribeapi.put("/v1/document/sign-off", confirm ? { ...body, confirm_visit_mismatch: true } : body);
  try {
    return await send(preConfirmed);
  } catch (err) {
    if (preConfirmed || !isVisitMismatchRefusal(err)) throw err;
    const ok = await requestSignMismatchConsent(mismatchDetailsFromRefusal(err.response.data));
    if (!ok) return { status: 499, result: false, cancelled: true, message: "Not signed." };
    return send(true);
  }
};
